import { useEffect, useState } from "react";
import { Share, Smartphone, X, Download, MoreVertical } from "lucide-react";

const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.matchMedia?.("(display-mode: fullscreen)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
const isMobile = () => /android|iphone|ipad|ipod/i.test(navigator.userAgent);

export function InstallBanner() {
  const [hidden, setHidden] = useState(() => isStandalone() || sessionStorage.getItem("orbit_install_dismissed") === "1");
  const [prompt, setPrompt] = useState(null);
  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", () => setHidden(true));
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);
  if (hidden) return null;
  const dismiss = () => { sessionStorage.setItem("orbit_install_dismissed", "1"); setHidden(true); };
  const install = async () => { if (!prompt) return; prompt.prompt(); const { outcome } = await prompt.userChoice; if (outcome === "accepted") setHidden(true); setPrompt(null); };
  const ios = isIOS();
  return (
    <div data-testid="pwa-install-banner" className="mt-6 rounded-2xl border border-blue-100 bg-blue-50/70 p-4 flex gap-3 relative">
      <button onClick={dismiss} data-testid="pwa-install-dismiss" aria-label="Fermer" className="absolute top-2 right-2 text-slate-400 hover:text-slate-700"><X className="w-4 h-4"/></button>
      <div className="w-9 h-9 rounded-xl bg-white grid place-items-center shrink-0 shadow-sm"><Smartphone className="w-4 h-4 text-blue-600"/></div>
      <div className="min-w-0 pr-5">
        <div className="font-semibold text-sm text-slate-900">Installez Orbit sur votre téléphone</div>
        {prompt ? (
          <button onClick={install} data-testid="pwa-install-button" className="mt-2 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-blue-600 text-white text-xs font-semibold hover:bg-blue-700"><Download className="w-3.5 h-3.5"/> Installer l'application</button>
        ) : (
          <p data-testid="pwa-install-instructions" className="text-xs text-slate-600 leading-snug mt-0.5">
            {ios || !isMobile()
              ? <>Appuyez sur <span className="inline-flex items-center gap-1 font-semibold text-slate-800"><Share className="w-3 h-3"/> Partager</span> puis <span className="font-semibold text-slate-800">Ajouter à l'écran d'accueil</span>.</>
              : <>Ouvrez le menu <span className="inline-flex items-center gap-1 font-semibold text-slate-800"><MoreVertical className="w-3 h-3"/></span> de votre navigateur puis <span className="font-semibold text-slate-800">Installer l'application</span> ou <span className="font-semibold text-slate-800">Ajouter à l'écran d'accueil</span>.</>}
          </p>
        )}
      </div>
    </div>
  );
}
